import {
  FILTERS_RESET,
  FILTERS_SET_CURRENT_CATEGORY,
  FILTERS_SET_CURRENT_GROUP,
  FILTERS_SET_STATE,
  FILTERS_SET_VALUES,
  FILTERS_UPDATE_CURRENT_CATEGORY,
  FILTERS_UPDATE_CURRENT_GROUP,
  FILTERS_UPDATE_DATA,
  FILTERS_UPDATE_VALUES
} from './types';

export const actions = {
  [FILTERS_RESET]: ({commit}) => {
    commit(FILTERS_SET_STATE, {
      categories: [],
      currentCategory: '',
      currentGroup: '',
      data: {},
      id: '',
      params: {},
      values: {},
      isExportDetail: false
    });
  },

  [FILTERS_UPDATE_CURRENT_CATEGORY]: ({commit}, payload) => {
    commit(FILTERS_SET_CURRENT_CATEGORY, payload);
  },

  [FILTERS_UPDATE_CURRENT_GROUP]: ({commit}, payload) => {
    commit(FILTERS_SET_CURRENT_GROUP, payload);
  },

  [FILTERS_UPDATE_DATA]: ({commit}, payload) => {
    commit(FILTERS_SET_STATE, payload);
  },

  [FILTERS_UPDATE_VALUES]: ({commit}, payload) => {
    commit(FILTERS_SET_VALUES, payload);
  }
};
